(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["caviar-showcase"] && !Shopify.designMode) return;
  try {
    
  class CaviarCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-carousel-track]');
      this.prevButton = this.querySelector('[data-carousel-prev]');
      this.nextButton = this.querySelector('[data-carousel-next]');

      if (!this.track) return;

      this.update = this.update.bind(this);

      if (this.prevButton) {
        this.prevButton.addEventListener('click', () => this.step(-1));
      }
      if (this.nextButton) {
        this.nextButton.addEventListener('click', () => this.step(1));
      }

      this.track.addEventListener('scroll', this.update, { passive: true });
      window.addEventListener('resize', this.update);
      this.update();
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.update);
    }

    step(direction) {
      const item = this.track.firstElementChild;
      const distance = item ? item.getBoundingClientRect().width : this.track.clientWidth;
      this.track.scrollBy({ left: direction * distance, behavior: 'smooth' });
    }

    update() {
      const maxScroll = this.track.scrollWidth - this.track.clientWidth;
      const position = Math.abs(this.track.scrollLeft);
      const scrollable = maxScroll > 1;

      this.classList.toggle('caviar-showcase__carousel--static', !scrollable);

      if (this.prevButton) {
        this.prevButton.disabled = !scrollable || position <= 1;
      }
      if (this.nextButton) {
        this.nextButton.disabled = !scrollable || position >= maxScroll - 1;
      }
    }
  }

  if (!customElements.get('caviar-carousel')) {
    customElements.define('caviar-carousel', CaviarCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter"] && !Shopify.designMode) return;
  try {
    
  // Honeypot guard. The field is invisible, untabbable and aria-hidden, so any
  // value in it came from a bot filling every input on the page.
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.classList || !form.classList.contains('newsletter__form')) return;

    var honeypot = form.querySelector('.newsletter__honeypot');
    if (honeypot && honeypot.value !== '') {
      event.preventDefault();
    }
  });

  } catch(e) { console.error(e); }
})();
})();
